export default {
  feedback: {
    title: 'Resposta enviada!',
    description: 'Agradecemos por nos ajudar a melhorar a experiência de crédito.',
    actionButtonText: 'Fechar'
  },
  scoreQuestion: {
    buttonLabel: 'Enviar resposta',
    lowerLabel: 'Pouco desapontado',
    upperLabel: 'Muito desapontado'
  },
  multipleChoiceQuestion: {
    buttonLabel: 'Enviar resposta',
    outrosLabel: 'Outros',
    customTextPlaceholder: 'Digite sua resposta aqui...',
    customTextLabel: 'Descreva sua resposta'
  },
  yesNoQuestion: {
    buttonLabel: 'Enviar resposta',
    yesLabel: 'Sim',
    noLabel: 'Não'
  },
  freeTextQuestion: {
    buttonLabel: 'Enviar resposta',
    placeholder: 'Digite sua resposta aqui...',
    placeholderTextarea: 'Digite sua resposta aqui...'
  }
}
